import { Box, Link, Typography } from '@mui/material';

import { AuthFooterProps } from './types';

export default function AuthFooter({
  contactEmail,
  indexUrl,
  brand
}: AuthFooterProps) {
  return (
    <Box
      component="div"
      display="flex"
      position="fixed"
      bottom={0}
      alignSelf="center"
    >
      <Link href={indexUrl}>
        <Typography
          sx={{
            color: '#767676',
            fontWeight: '700',
            fontSize: '12px',
            lineHeight: '18px'
          }}
          pb="29px"
          pr="16px"
        >
          © {brand.toLowerCase()}
        </Typography>
      </Link>
      {Boolean(contactEmail) && (
        <>
          <Typography
            sx={{
              color: '#767676',
              fontWeight: '700',
              fontSize: '12px',
              lineHeight: '18px'
            }}
            pb="29px"
            pr="16px"
          >
            .
          </Typography>
          <Link href={`mailto:${contactEmail}`}>
            <Typography
              sx={{
                color: '#767676',
                fontWeight: '700',
                fontSize: '12px',
                lineHeight: '18px'
              }}
              paddingBottom="29px"
              paddingRight="16px"
            >
              Contact
            </Typography>
          </Link>
        </>
      )}
      {/* keep for future */}
      {/* <Typography
        sx={{
          color: '#767676',
          fontWeight: '700',
          fontSize: '12px',
          lineHeight: '18px'
        }}
        pb="29px"
        pr="16px"
      >
        .
      </Typography> */}
      {/* <Link>
        <Typography
          sx={{
            color: '#767676',
            fontWeight: '700',
            fontSize: '12px',
            lineHeight: '18px'
          }}
          pb="29px"
        >
          Privacy & terms
        </Typography>
      </Link> */}
    </Box>
  );
}
